var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AFRAME } from "../../react/root";
import { createElement } from "../../util";
import mixin from "./mixin";
export default function () {
    AFRAME.registerComponent('radiocomponent', __assign(__assign({ schema: {
            options: { type: 'string', default: '' },
            value: { type: 'string', default: '' },
            paddingRight: { type: 'number', default: .05 },
            direction: { type: 'string', default: '' }
        }, init: function () {
            var me = this;
            me.radioContainer = null;
            this.render();
        }, update: function (oldData) {
            var me = this;
            if (oldData.options !== this.data.options) {
                this.render();
            }
            if (!oldData.value || oldData.value !== this.data.value) {
                me.updateChecked();
            }
        }, updateChecked: function () {
            var me = this;
            if (me.optionValues) {
                Object.keys(me.optionValues).map(function (key) {
                    if (me.optionValues[key]) {
                        me.optionValues[key].setAttribute('checked', me.data.value === key);
                    }
                });
            }
        }, render: function () {
            var me = this;
            if (me.radioContainer) {
                me.radioContainer.parentNode.removeChild(me.radioContainer);
            }
            me.optionValues = {};
            me.options = JSON.parse(this.data.options);
            if (this.data.options) {
                if (this.data.options) {
                    var buttonContainer_1 = document.createElement('frame-container');
                    buttonContainer_1.setAttribute('direction', this.data.direction || 'horizontal');
                    buttonContainer_1.setAttribute('alignment', 'flexStart');
                    buttonContainer_1.setAttribute('margin', '0 0 0 0');
                    me.options.map(function (option) {
                        var _a, _b;
                        var button = createElement("frame-base-interactive", (_a = {
                                width: option.width || .3,
                                height: me.data.optionHeight || .2,
                                margin: '0 0 0 0',
                                value: option.text || option.value
                            },
                            _a["interactive-type"] = option.type || 'radio',
                            _a['font-size'] = .07,
                            _a))();
                        button.setAttribute('resize-on-text', true);
                        button.addEventListener('click', function (evt) {
                            var _a;
                            if (me.data.value !== option.value) {
                                (_a = me === null || me === void 0 ? void 0 : me.el) === null || _a === void 0 ? void 0 : _a.setAttribute('value', option.value);
                                me.el.emit('change', {
                                    value: option.value
                                });
                            }
                            me.data.value = option.value;
                            me.el.emit('click', {
                                value: option.value
                            });
                            evt.preventDefault();
                        });
                        me.optionValues = __assign(__assign({}, me.optionValues), (_b = {}, _b[option.value] = button, _b));
                        buttonContainer_1.appendChild(button);
                    });
                    me.radioContainer = buttonContainer_1;
                    me.radioContainer.addEventListener('size-update', function (evt) {
                        me.updateElementSize(me.radioContainer, me.el);
                    });
                    me.el.appendChild(me.radioContainer);
                    me.updateChecked();
                    me.updateElementSize(me.radioContainer, me.el);
                }
            }
        } }, mixin), { getWidth: function () {
            var me = this;
            return parseFloat("".concat(me.radioContainer.getWidth()));
        }, getHeight: function () {
            var me = this;
            return parseFloat("".concat(me.radioContainer.getHeight()));
        } }));
    AFRAME.registerPrimitive('frame-radio', {
        defaultComponents: {
            'radiocomponent': {},
        },
        mappings: {
            'options': 'radiocomponent.options',
            'value': 'radiocomponent.value',
            direction: 'radiocomponent.direction',
        }
    });
}
